"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("@apollo/client");
var react_1 = __importStar(require("react"));
var react_confirm_alert_1 = require("react-confirm-alert");
require("react-confirm-alert/src/react-confirm-alert.css"); // Import css
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var Button_1 = __importDefault(require("../../../../../common/Button/Button"));
var ImagePicker_1 = __importDefault(require("../../../../../common/ImagePicker/ImagePicker"));
// import Modal from "../../../../../common/Modal/Modal";
var react_modal_1 = __importDefault(require("react-modal"));
var Spinner_1 = __importDefault(require("../../../../../common/Spinner/Spinner"));
var TextArea_1 = __importDefault(require("../../../../../common/TextInput/TextArea"));
var TextInput_1 = __importDefault(require("../../../../../common/TextInput/TextInput"));
var Toast_1 = require("../../../../../common/Toast");
var localStorage_1 = __importDefault(require("../../../../../config/localStorage"));
var org_hook_1 = require("../../../../../context/OrgContext/org.hook");
var general_1 = require("../../../../../lib/general");
var getValVideo_1 = require("../../../../../lib/getValVideo");
var HeaderBar_1 = __importDefault(require("../../../../../theme/headerbar/HeaderBar"));
var icons_1 = __importDefault(require("../../../../../theme/icons"));
var SortingSelector_1 = __importDefault(require("../../../Disease/Selectors/SortingSelector"));
var Mutation_1 = require("../../Graphql/Mutation");
var Queries_1 = require("../../Graphql/Queries");
var ServiceCategorySelector_1 = __importDefault(require("../../Selector/ServiceCategorySelector"));
var ServiceCenterForm_1 = __importDefault(require("../ServiceCenter/ServiceCenterForm"));
var ServiceTable_1 = __importDefault(require("../ServiceTable"));
require("../style.scss");
var ValidateServiceForm_1 = require("../ValidateServiceForm");
var Service = function (props) {
    var _a, _b;
    var state = (0, react_router_dom_1.useLocation)().state, iconRef = (0, react_1.createRef)(), videoRef = (0, react_1.createRef)(), _c = (0, react_i18next_1.useTranslation)(), t = _c.t, i18n = _c.i18n, history = (0, react_router_dom_1.useHistory)(), organization = (0, org_hook_1.useOrg)().organization, getCurrentLang = i18n.language;
    var _d = (0, react_1.useState)(null), error = _d[0], setError = _d[1], _e = (0, react_1.useState)(state.center), center = _e[0], setCenter = _e[1], _f = (0, react_1.useState)(""), success = _f[0], setSuccess = _f[1], _g = (0, react_1.useState)(false), isOpen = _g[0], setIsOpen = _g[1], _h = (0, react_1.useState)(false), editOpen = _h[0], setEditOpen = _h[1], _j = (0, react_1.useState)(false), loading = _j[0], setLoading = _j[1], _k = (0, react_1.useState)({ en: "", fr: "", rn: "" }), langauges = _k[0], setLanguages = _k[1], _l = (0, react_1.useState)({
        id: null,
        name: JSON.stringify(langauges),
        address: "",
        phone_number: "",
        email: "",
        category: null,
        service_center_id: center.id,
        description: JSON.stringify(langauges),
        icon: null,
        thumbnail: langauges,
        video: langauges,
        sorting: null,
        website: "",
        service_category: null,
    }), formData = _l[0], setFormData = _l[1], _m = (0, react_1.useState)({
        icon: null,
        thumbnail: null,
        video: null,
    }), fileName = _m[0], setFileName = _m[1], _o = (0, react_1.useState)(""), fosaUser = _o[0], setFosaUser = _o[1];
    var getLanguages = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, tmp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, localStorage_1.default.getItem("languages")];
                case 1:
                    data = _a.sent(), tmp = {};
                    data.map(function (l) {
                        return Object.entries(l).map(function (_a) {
                            var _b;
                            var key = _a[0], value = _a[1];
                            if (key === "value") {
                                Object.assign(tmp, (_b = {}, _b[value] = "", _b));
                            }
                        });
                    });
                    setLanguages(tmp);
                    return [2 /*return*/];
            }
        });
    }); };
    var getAllServiceCenterByOrganization = (0, client_1.useLazyQuery)(Queries_1.GET_SERVICE_CENTER_BY_ORGANIZATION, {
        variables: { organization_id: organization.id },
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "network-only",
        onCompleted: function (data) {
            setLoading(false);
            setCenter(data.getAllServiceCenterByOrganization.filter(function (centerData) { return centerData.id === center.id; })[0]);
        },
        onError: function () {
            setLoading(false);
        },
    })[0];
    var callUpsertService = (0, client_1.useMutation)(Mutation_1.UPSERT_SERVICE, {
        fetchPolicy: "network-only",
        // refetchQueries: ["getAllServiceCenterByOrganization"],
    })[0];
    var callDeleteServiceCenter = (0, client_1.useMutation)(Mutation_1.DELETE_SERVICE_CENTER, {
        fetchPolicy: "network-only",
        // refetchQueries: ["getAllServiceCenterByOrganization"],
    })[0];
    var _p = (0, client_1.useMutation)(Mutation_1.DELETE_SERVICE, {
        fetchPolicy: "network-only",
        refetchQueries: ["getAllServiceCenterByOrganization"],
    }), callDeleteService = _p[0], responseDeleteService = _p[1];
    var _q = (0, client_1.useMutation)(Mutation_1.UPSERT_USER_SERVICE_CENTER, {
        fetchPolicy: "no-cache",
    }), callUpsertUserServiceCenter = _q[0], responseUpsertUserServiceCenter = _q[1];
    var resetDocumentRef = function () {
        iconRef.current.value = null;
        videoRef.current.value = null;
    };
    (0, react_1.useEffect)(function () {
        getLanguages();
    }, []);
    (0, react_1.useEffect)(function () {
        // reformatParam();
        resetDocumentRef();
    }, [getCurrentLang]);
    var reformatParam = function () {
        var reformat = {
            id: null,
            name: JSON.stringify(langauges),
            description: JSON.stringify(langauges),
            icon: null,
            thumbnail: langauges,
            video: langauges,
            sorting: null,
            service_category: null,
            service_center_id: center.id,
        };
        setFileName({
            icon: null,
            thumbnail: null,
            video: null,
        });
        setFormData(reformat);
    };
    (0, react_1.useEffect)(function () {
        if (success) {
            var timer_1 = setTimeout(function () {
                setSuccess("");
            }, 5000);
            return function () { return clearTimeout(timer_1); };
        }
    }, [success]);
    var onDeleteServiceCenter = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, callDeleteServiceCenter({
                        variables: {
                            id: center.id,
                            organization_id: organization.id,
                        },
                    })];
                case 1:
                    _a.sent();
                    history.push("/admin/service_center");
                    return [2 /*return*/];
            }
        });
    }); };
    var onHandleChange = function (value, data_type, isJson) {
        setError(null);
        if (isJson === "json") {
            var dataObj_1 = JSON.parse(formData[data_type]);
            dataObj_1[getCurrentLang] = value;
            setFormData(function (prevState) {
                var _a;
                return (__assign(__assign({}, prevState), (_a = {}, _a[data_type] = JSON.stringify(dataObj_1), _a)));
            });
        }
        else if (isJson === "obj") {
            var currentInput_1 = data_type;
            var video_file_1 = value.video_file, thumbnail_file_1 = value.thumbnail_file;
            if (video_file_1) {
                setFileName(function (prevState) {
                    var _a;
                    return (__assign(__assign({}, prevState), (_a = {}, _a[currentInput_1] = video_file_1.name, _a)));
                });
                setFormData(function (prevState) {
                    var _a, _b;
                    return (__assign(__assign({}, prevState), (_a = {}, _a[currentInput_1] = __assign(__assign({}, prevState[currentInput_1]), (_b = {}, _b[getCurrentLang] = video_file_1, _b)), _a)));
                });
            }
            if (thumbnail_file_1) {
                setFormData(function (prevState) {
                    var _a, _b;
                    return (__assign(__assign({}, prevState), (_a = {}, _a["thumbnail"] = __assign(__assign({}, prevState["thumbnail"]), (_b = {}, _b[getCurrentLang] = thumbnail_file_1, _b)), _a)));
                });
            }
        }
        else {
            if (data_type === "icon") {
                setFileName(function (prevState) {
                    var _a;
                    return (__assign(__assign({}, prevState), (_a = {}, _a[data_type] = value.name, _a)));
                });
            }
            setFormData(function (prevState) {
                var _a;
                return (__assign(__assign({}, prevState), (_a = {}, _a[data_type] = value, _a)));
            });
        }
    }, saveService = function () {
        var res = (0, ValidateServiceForm_1.ValidateService)(formData);
        if (res.status === "error") {
            setError(res);
        }
        else {
            window.scrollTo(0, 0);
            setLoading(true);
            var service_categories_format = formData.service_category;
            var tmp_1 = [];
            if (service_categories_format.length > 0) {
                service_categories_format.map(function (l) {
                    tmp_1.push({ id: l.value });
                });
            }
            var variables = {
                name: formData.name,
                service_center_id: center.id,
                service_media: {
                    icon: formData.icon,
                    thumbnail: (0, getValVideo_1.getVal)(formData.thumbnail),
                    video: (0, getValVideo_1.getVal)(formData.video),
                },
                description: formData.description,
                service_id: formData.id,
                sorting: typeof formData.sorting === "object" && formData.sorting !== null
                    ? formData.sorting.sorting_id
                    : parseInt(formData.sorting),
                organization_id: organization.id,
                service_categories: tmp_1,
            };
            // props.saveEducation(formData);
            callUpsertService({
                variables: variables,
            })
                .then(function (res) {
                setLoading(false);
                setSuccess(res.data.upsertService);
                getAllServiceCenterByOrganization({
                    variables: {
                        organization_id: organization.id,
                    },
                });
                reformatParam();
            })
                .catch(function (e) {
                setSuccess("");
                setLoading(false);
                return e;
            });
        }
    };
    var onFosaSaveClick = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var data, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, callUpsertUserServiceCenter({
                            variables: { umva_id: fosaUser, service_center_id: center.id },
                        })];
                case 2:
                    data = (_a.sent()).data;
                    response = data.assignUserToServiceCenter;
                    setLoading(false);
                    setFosaUser("");
                    // {
                    //   responseUpsertUserServiceCenter?.data &&
                    //     responseUpsertUserServiceCenter?.data?.assignUserToServiceCenter ==
                    //       null &&
                    //     setFosaUser(fosaUser);
                    // }
                    // setFosaUser("");
                    if (response === null) {
                        setLoading(true);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.log("fosa manager error", error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var resetFosa = function () {
        setFosaUser("");
    };
    var triggerButton = function () { return (react_1.default.createElement("div", { style: { top: "8.3rem" } },
        react_1.default.createElement(Button_1.default, { className: "form-buttom", icon: react_1.default.createElement(icons_1.default, { name: "fosa", className: "icon", height: 30, width: 30 }), text: t("add_fosa_manager"), onClick: function () { return setIsOpen(true); } }))); };
    var createFOSA = function () { return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TextInput_1.default, { label: t("umva_id"), value: fosaUser, onChange: function (e) {
                setFosaUser(e.target.value);
            } }),
        react_1.default.createElement(TextInput_1.default, { label: t("health_center"), value: (0, general_1.isJsonWithAvailableLang)(center.name, getCurrentLang, t), disabled: true }))); };
    var detailForm = function () {
        return (react_1.default.createElement("div", { style: { display: "flex", justifyContent: "space-between" } },
            react_1.default.createElement("div", { className: "form-container" },
                react_1.default.createElement(ServiceCategorySelector_1.default, { label: t("service_category"), error: error && error.field === "service_category" && error.message, onChange: function (val) {
                        setFormData(function (prev) { return (__assign(__assign({}, prev), { service_category: val })); });
                    }, value: formData.service_category }),
                react_1.default.createElement(TextInput_1.default, { error: error && error.field === "name" && error.message, label: t("name"), onChange: function (e) {
                        return onHandleChange(e.target.value, "name", "json");
                    }, value: (0, general_1.isJsonWithAvailableLang)(formData.name, getCurrentLang.toLowerCase(), t) }),
                react_1.default.createElement(TextArea_1.default, { label: t("description"), onChange: function (e) {
                        return onHandleChange(e.target.value, "description", "json");
                    }, value: (0, general_1.isJsonWithAvailableLang)(formData.description, getCurrentLang.toLowerCase(), t) }),
                react_1.default.createElement(ImagePicker_1.default, { fileName: fileName, id: "icon", imagechange: function (file) {
                        onHandleChange(file, "icon", "icon");
                    }, imgref: iconRef, label: t("Logo"), mediatype: "image" }),
                react_1.default.createElement(ImagePicker_1.default, { fileName: fileName, id: "video", imagechange: function (video_file, thumbnail_file) {
                        var file = { video_file: video_file, thumbnail_file: thumbnail_file };
                        onHandleChange(file, "video", "obj");
                    }, imgref: videoRef, label: t("video"), mediatype: "video" }),
                react_1.default.createElement(SortingSelector_1.default, { list: props.categoryList, onChange: function (e) {
                        onHandleChange(e, "sorting", "");
                    }, value: formData.sorting, label: t("sorting_order") }),
                react_1.default.createElement(Button_1.default, { onClick: function () {
                        saveService();
                    }, 
                    // className={"modal-button"}
                    text: t("save"), className: "form-buttom", style: {
                        marginTop: "3vh",
                        padding: "0px 1rem",
                        // background: "#009cff",
                        height: "3vh",
                    } })),
            react_1.default.createElement("div", null,
                triggerButton(),
                react_1.default.createElement(react_modal_1.default, { isOpen: isOpen, onRequestClose: function () {
                        setIsOpen(false);
                        resetFosa();
                    }, 
                    // contentLabel="Add Category Modal"
                    style: {
                        content: {
                            top: "50%",
                            left: "50%",
                            right: "auto",
                            bottom: "auto",
                            marginRight: "-50%",
                            transform: "translate(-50%, -50%)",
                            width: "75%",
                            // height: "75%",
                        },
                    } },
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { style: {
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                            } },
                            react_1.default.createElement("h2", null, t("add_fosa_manager")),
                            react_1.default.createElement("div", { style: {
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginTop: "1rem",
                                    marginBottom: "1rem",
                                } },
                                react_1.default.createElement(Button_1.default, { className: "modal-button", onClick: function () {
                                        setIsOpen(false);
                                        resetFosa();
                                    }, icon: react_1.default.createElement(icons_1.default, { name: "cancel", className: "icon", height: 20, width: 20 }) }),
                                react_1.default.createElement(Button_1.default, { className: "modal-button", icon: react_1.default.createElement(icons_1.default, { name: "tick", className: "icon", height: 30, width: 30 }), onClick: function (e) {
                                        onFosaSaveClick(e);
                                        setIsOpen(false);
                                    }, style: { marginLeft: 2 } }))),
                        createFOSA())))));
    };
    var onEditService = function (params) {
        window.scrollTo(0, 0);
        var reformat = {
            id: params.id,
            name: params.name,
            address: params.address,
            phone_number: params.phone,
            email: params.email,
            category: params.service_center_id,
            description: params.description,
            icon: null,
            thumbnail: langauges,
            video: langauges,
            sorting: params.sorting,
            website: params.website,
            service_category: params.service_categories.map(function (service) {
                return {
                    value: service.id,
                    label: (0, general_1.isJsonWithAvailableLang)(service.name, getCurrentLang, t),
                };
            }),
        };
        setFormData(reformat);
    };
    var onDeleteService = function (params) {
        callDeleteService({
            variables: {
                id: params.id,
                organization_id: params.organization_id,
                service_center_id: params.service_center_id,
            },
        })
            .then(function (res) {
            setSuccess(res.data.deleteService);
        })
            .catch(function () {
            setSuccess("");
        });
    };
    return (react_1.default.createElement("div", { style: { display: "flex", flexDirection: "column", flex: 1 } },
        react_1.default.createElement(HeaderBar_1.default, { title: t("service_center") +
                " : " +
                (0, general_1.isJsonWithAvailableLang)(center.name, getCurrentLang, t), hideSave: true, extraComponent: react_1.default.createElement("div", { style: { display: "flex", flexDirection: "row" } },
                react_1.default.createElement(Button_1.default, { className: "form-buttom", style: {
                        background: "none",
                        border: "none",
                        boxShadow: "none",
                    }, icon: react_1.default.createElement(icons_1.default, { name: "edit", className: "icon icon_black", height: 30, width: 30 }), onClick: function () { return setEditOpen(true); } }),
                react_1.default.createElement(react_modal_1.default, { contentLabel: t("edit_service_center"), isOpen: editOpen, style: {
                        content: {
                            top: "50%",
                            left: "50%",
                            right: "auto",
                            bottom: "auto",
                            marginRight: "-50%",
                            transform: "translate(-50%, -50%)",
                            width: "75%",
                            height: "75%",
                        },
                    }, ariaHideApp: false },
                    react_1.default.createElement("div", { style: {
                            display: "flex",
                            justifyContent: "space-between",
                            marginTop: "1rem",
                            marginBottom: "1rem",
                        } },
                        react_1.default.createElement("h2", null, t("edit_service_center")),
                        react_1.default.createElement(Button_1.default, { className: "modal-button", onClick: function () {
                                setEditOpen(false);
                                // resetForm();
                            }, icon: react_1.default.createElement(icons_1.default, { name: "cancel", className: "icon", height: 20, width: 20 }) })),
                    react_1.default.createElement(ServiceCenterForm_1.default, { list: [], editData: center })),
                react_1.default.createElement(Button_1.default, { className: "form-buttom", style: {
                        background: "none",
                        border: "none",
                        boxShadow: "none",
                    }, icon: react_1.default.createElement(icons_1.default, { name: "delete", className: "icon icon_black", height: 30, width: 30 }), onClick: function () {
                        return (0, react_confirm_alert_1.confirmAlert)({
                            customUI: function (_a) {
                                var onClose = _a.onClose;
                                return (react_1.default.createElement("div", { className: "custom-ui" },
                                    react_1.default.createElement("h1", null, t("are_you_sure?")),
                                    react_1.default.createElement("p", null, t("you_want_to_delete {{service_center}} ?", {
                                        service_center: (0, general_1.isJsonWithAvailableLang)(center.name, getCurrentLang, t),
                                    })),
                                    react_1.default.createElement("button", { onClick: onClose }, t("no")),
                                    react_1.default.createElement("button", { onClick: function () {
                                            onDeleteServiceCenter();
                                            onClose();
                                        } }, t("yes"))));
                            },
                        });
                    } })) },
            react_1.default.createElement(react_1.default.Fragment, null,
                (loading ||
                    (responseDeleteService === null || responseDeleteService === void 0 ? void 0 : responseDeleteService.loading) ||
                    responseUpsertUserServiceCenter.loading) && react_1.default.createElement(Spinner_1.default, null),
                (responseUpsertUserServiceCenter === null || responseUpsertUserServiceCenter === void 0 ? void 0 : responseUpsertUserServiceCenter.data) &&
                    ((_a = responseUpsertUserServiceCenter === null || responseUpsertUserServiceCenter === void 0 ? void 0 : responseUpsertUserServiceCenter.data) === null || _a === void 0 ? void 0 : _a.assignUserToServiceCenter) !==
                        null && (react_1.default.createElement(Toast_1.ToastSuccess, { autoClose: 5000, closeOnClick: true, draggable: true, hideProgressBar: true, message: t("user_assigned_successfully"), newestOnTop: false, onClose: true, pauseOnFocusLoss: true, pauseOnHover: true, position: "top-center", rtl: false })),
                ((_b = responseUpsertUserServiceCenter === null || responseUpsertUserServiceCenter === void 0 ? void 0 : responseUpsertUserServiceCenter.data) === null || _b === void 0 ? void 0 : _b.assignUserToServiceCenter) ===
                    null &&
                    (responseUpsertUserServiceCenter === null || responseUpsertUserServiceCenter === void 0 ? void 0 : responseUpsertUserServiceCenter.error) && (react_1.default.createElement(Toast_1.ToastSuccess, { autoClose: 4000, closeOnClick: true, draggable: true, hideProgressBar: true, message: t("user_not_assigned"), newestOnTop: false, onClose: true, pauseOnFocusLoss: true, pauseOnHover: true, position: "top-center", rtl: false })),
                detailForm(),
                react_1.default.createElement(ServiceTable_1.default, { list: [center], onDelete: function (item) {
                        onDeleteService(item);
                    }, onEdit: function (item) {
                        onEditService(item);
                    } })))));
};
exports.default = Service;
